/* Helite Newsletter footer sign-up. Posts to Klaviyo's client subscriptions API. */
(function () {
  function init(root) {
    var form = root.querySelector('.hn-form');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';
    var input = root.querySelector('.hn-input');
    var btn = root.querySelector('.hn-btn');
    var fine = root.querySelector('.hn-fine');
    var msg = root.querySelector('.hn-msg');
    function show(text, isError) {
      msg.textContent = text;
      msg.classList.toggle('is-error', !!isError);
      msg.hidden = false;
      if (fine) fine.hidden = true;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.company && form.company.value) return;
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show(form.dataset.invalid, true); input.focus(); return; }
      var key = form.dataset.key, list = form.dataset.list;
      if (!key || !list) { show(form.dataset.err, true); return; }
      btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Website footer sign-up',
          profile: { data: { type: 'profile', attributes: {
            email: email,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        form.hidden = true;
        show(form.dataset.ok, false);
      }).catch(function () {
        btn.disabled = false;
        show(form.dataset.err, true);
      });
    });
  }
  function run() { document.querySelectorAll('.hn').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
